<ul class="notifications__container l-container">
    @for (notification of notifications; track $index) {
        <li>
            <tg-info-box
                class="notification__info-box"
                (click)="dismiss(notification)"
                [tgStyle]="getType(notification)"
                [ngClass]="{
                'notification__info-box--compact': isCompact
            }"
            >
                @if (notification.type === notificationTypeEnum.success) {
                    <tg-icon
                        role="presentation"
                        name="basic-tick-framed"
                    >
                    </tg-icon>
                }
                @if (notification.type === notificationTypeEnum.primary) {
                    <tg-icon
                        role="presentation"
                        name="basic-info-framed"
                    >
                    </tg-icon>
                }
                @if (notification.type === notificationTypeEnum.warning) {
                    <tg-icon
                        role="presentation"
                        name="lightbulb"
                    >
                    </tg-icon>
                }
                @if (notification.type === notificationTypeEnum.danger) {
                    <tg-icon
                        role="presentation"
                        name="basic-warning-framed"
                    >
                    </tg-icon>
                }
                @if (notification.title) {
                    <tg-info-box-heading>
                        {{ notification.title }}
                    </tg-info-box-heading>
                }
                {{ notification.message }}
                @if (notification.action) {
                    <tg-info-box-actions>
                        <button tgButton2 transparent (click)="onAction(notification)">
                            {{ notification.action.text }}
                        </button>
                    </tg-info-box-actions>
                }
            </tg-info-box>
        </li>
    }
</ul>
